module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-selected.4e2e1778.svg";